const ja = {
  100000001:'重要な情報',
  100000002:'トークン名',
  100000003:'コピー作成者',
  100000004:'コピーの作成時間',
  100000005:'基本情報',
  100000006:'所属パブリックチェーン/プロトコル',
  100000007:'スマートコントラクトアドレス',
  100000008:'公開時間',
  100000009:'発行の総量',
  100000010:'流通の総量',
  100000011:'市場価格',
  100000012:'紹介',
  100000013:'ソーシャルメディア情報',
  100000014:'公式サイト',
  100000015:'ホワイトペーパー',
  100000016:'ブロックチェーンエクスプローラー',
  100000017:'プロジェクト評価',
  100000018:'ランキング',
  100000019:'上位',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'更新時間',
  100000027:'セキュリティスコア',
  100000028:'コントラクトセキュリティスコア',
  100000029:'リスクプロジェクトの統計',
  100000030:'契約コードの詳細',
  100000031:'購入税',
  100000032:'売上税',
  100000033:'ハニーポットかどうか',
  100000034:'再ミント可能かどうか',
  100000035:'ブラックリストがありますか',
  100000036:'ホワイトリストがありますか',
  100000037:'反クジラかどうか',
  100000038:'税率を変更できるか',
  100000039:'オープンソースかどうか',
  100000040:'隠れた保有者がいるかどうか',
  100000041:'自壊可能かどうか',
  100000042:'プロキシ契約かどうか',
  100000043:'残高を変更できますか',
  100000044:'外部呼び出しを実行できますか',
  100000045:'所有権を再取得できますか',
  100000046:'取引のクーリングオフ期間はありますか',
  100000047:' 送金を一時停止できますか',
  100000048:'所有権が放棄されていない',
  100000049:'調整可能なアンチホエールですか',
  100000050:'小数点以下の桁数が多すぎる',
  100000051:'公開されているミントとバーンの方法',
  100000052:'トークンを燃焼すると総量が更新されますか',
  100000053:'トークンを燃焼すると残高が更新されますか',
  100000054:'自己送金で残高が増加しますか',
  100000055:'残高より多くのトークンを送ると無効になりますか',
  100000056:'残高が送金中に更新されていない',
  100000057:'受取人の残高が消耗されますか',
  100000058:'TransferFromを呼び出すと残高を超えた場合に失敗しますか',
  100000059:'BurnFromメソッドは総量を更新しますか',
  100000060:'トークンの購入税を検出します5%以上は高税率と見なされます',
  100000061:'トークンの売却税を検出します5%以上は高税率と見なされます',
  100000062:'トークンがハニーポット詐欺であるか確認します',
  100000063:'さらにトークンを発行できるか確認します',
  100000064:'トークンにユーザーがトークンをスワップまたは転送することを制限できるブラックリストがあるか確認します',
  100000065:'制限を回避できるアドレスを許可するホワイトリストがトークンにあるか確認します',
  100000066:'トークンに反クジラメカニズムがあるか確認します',
  100000067:'トークンに税がありその税が特権を持つ役割によって変更可能かどうか確認します',
  100000068:'トークンがブロックチェーンエクスプローラーで検証されているか確認します',
  100000069:'所有権が放棄されたように見えても契約を操作できる隠れた所有者があるか確認します',
  100000070:'トークンが自己破壊可能か確認します',
  100000071:'トークンが実装契約に関数呼び出しを委任するプロキシ契約であるか確認します',
  100000072:'トークン残高が特権を持つ役割によって変更可能か確認します',
  100000073:'トークンが外部契約を呼び出すか確認します',
  100000074:'トークンに所有権を取り戻すためのバックドアがあるか確認します',
  100000075:'トークンに転送クールダウンメカニズムがあるか確認します',
  100000076:'特権を持つ役割によってトークン取引が一時停止可能か確認します',
  100000077:'所有者の特権が放棄されているか確認します',
  100000078:'トークンの反クジラメカニズムが特権を持つ役割によって変更可能か確認します',
  100000079:'decimals() 関数の戻り値が5以上か確認します',
  100000080:'ランダムなユーザーが mint() および burn() 関数を呼び出すとリバートするか確認します',
  100000081:'burn() 関数を呼び出すと totalSupply が正しく更新されるか確認します',
  100000082:"burnFrom() 関数を呼び出すと許可が正しく更新されるか確認します",
  100000083:'トランザクション送信者と同じ受信者で transfer() 関数を呼び出すと送信者の残高が増えるか確認します',
  100000084:'残高を超える金額で transfer() 関数を呼び出すと失敗するか確認します',
  100000085:"transferFrom() 関数を呼び出した後に支出者の許可が適切に更新されるか確認します",
  100000086:"transferFrom() 関数を呼び出すと支出者の残高が使用されるか確認します",
  100000087:"transferFrom()を呼び出した後に許可額が正しく更新されるか、または金額が無効な場合にトランザクションがリバートされるか確認してください。",
  100000088:"burnFrom()関数を呼び出すことでtotalSupplyが正しく更新されるか確認してください",
  100000089:'鋳造権が存在するか確認します',
  100000090:'凍結権が存在するか確認します',
  100000091:'メタデータが変更可能かどうか確認します',
  100000092:'クリティカル',
  100000093:'メジャー',
  100000094:'ミディアム',
  100000095:'マイナー',
  100000096:'インフォメーショナル',
  100000097:' Mint権限は放棄されましたか',
  100000098:' 凍結権限は放棄されましたか',
  100000099:' トークンのメタデータを変更できますか',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default ja


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/ja.js